import { render } from "./Tangent.vue?vue&type=template&id=60b4666e"
import script from "./Tangent.vue?vue&type=script&lang=js"
export * from "./Tangent.vue?vue&type=script&lang=js"

import "./Tangent.vue?vue&type=style&index=0&id=60b4666e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__